define(['ko', 'jquery', 'matchSize', 'slick'], (ko, $, matchSize) => {
    const defaultSpeed = 7000;

    return {
        init(options, element) {
            this.initCache(options, element);
            this.initEvents();
            this.initHomeBanner();
        },

        initCache(options, element) {
            this.options = options;
            this.$banner = $(element);
            this.$bannerContainer = this.$banner.parents();

            this.$bannerPreviewList = $('.js-home-banner-preview-list');
            this.$bannerPreviewItem = $('.js-banner-preview-item');
        },

        initEvents() {
            this.$bannerPreviewItem.on('click', this.showBannerItem.bind(this));
        },

        initHomeBanner() {
            this.$bannerContainer.addClass('_ready-to-show');

            this.$banner.on('init', () => {
                const firstSlideIndex = $('div[data-slick-index="0"]');

                if (firstSlideIndex) {
                    this.checkImage(true);
                }

                if (
                    !matchSize().mobile ||
                    this.$bannerPreviewList.find('.js-banner-preview-item')
                        .length < 4
                ) {
                    this.setFirstActivePreviewItem();
                }

                matchSize().mobile && this.initHomeBannerPreview();
            });

            this.$banner.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                pauseOnHover: false,
                pauseOnFocus: false,
                autoplay:
                    this.options.autoplay !== undefined
                        ? this.options.autoplay
                        : false,
                autoplaySpeed: this.options.autoplaySpeed || defaultSpeed,
                infinite: true,
                speed: 500,
                adaptiveHeight: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                            fade: false,
                        },
                    },
                ],
            });

            if (this.options.deferredAutoplay && matchSize().desktop) {
                this.$banner.slick('slickSetOption', 'autoplay', true, true);
            }

            this.$banner.on(
                'beforeChange',
                (event, slick, currentSlide, nextSlide) => {
                    if (currentSlide === nextSlide) {
                        return;
                    }

                    this.$bannerPreviewItem
                        .removeClass('_active')
                        .eq(nextSlide)
                        .addClass('_active');
                    this.$bannerContainer.removeClass('_ready-to-show');

                    this.changeClassArrows(
                        this.$banner.find(
                            '.js-home-banner-item[data-slick-index=' +
                                nextSlide +
                                ']'
                        )
                    );
                }
            );

            this.$banner.on('afterChange', () => this.checkImage());

            this.initSwipeLazyLoad(this.$banner);

            this.changeClassArrows(this.$banner.find('.js-home-banner-item'));
        },

        setFirstActivePreviewItem() {
            const $firstPreview = $(this.$bannerPreviewItem[0]);

            $firstPreview.addClass('_active');
        },

        checkImage(waitForLoad) {
            const $active = this.$banner.find('.slick-active');
            const delay = (this.options.autoplaySpeed || defaultSpeed) - 1000;
            const $nextItem = $active.next();

            if (this.options.deferredAutoplay) {
                this.loadImage($active, false, waitForLoad);

                if (matchSize().desktop) {
                    setTimeout(() => {
                        this.loadImage($nextItem, true);
                    }, delay);
                }
            }
        },

        loadNextSliderImage() {
            const $active = this.$banner.find('.slick-active');

            this.loadImage($active.next(), true);
        },

        loadPrevSliderImage() {
            const $active = this.$banner.find('.slick-active');

            this.loadImage($active.prev(), true);
        },

        loadImage($slide, forceLoad, waitForLoad) {
            const $inner = $slide.find('.js-home-banner-image');

            $inner.each((i, el) => {
                const $item = $(el);
                const src = matchSize().mobile
                    ? $item.attr('data-mobile-src')
                    : $item.attr('data-src');
                const isVisible = $item.is(':visible');
                const canLoad = src && (forceLoad || isVisible);

                if (!canLoad) {
                    return;
                }

                if (!waitForLoad) {
                    this.setElementImage($item, src);

                    return;
                }

                const loader = new Image();

                loader.src = src;
                loader.addEventListener('load', () => {
                    this.setElementImage($item, src);
                });
            });
        },

        setElementImage($item, src) {
            $item.css('background-image', `url("${src}")`);
        },

        initSwipeLazyLoad($banner) {
            $banner.on('touchstart mousedown', () => {
                this.loadNextSliderImage();
                this.loadPrevSliderImage();
            });
        },

        showBannerItem(ev) {
            const $previewItem = $(ev.currentTarget);
            const id = $previewItem.data('preview-id');

            this.$banner.slick('slickGoTo', Number(id), false);
        },

        initHomeBannerPreview() {
            if (
                this.$bannerPreviewList.find('.js-banner-preview-item').length <
                4
            ) {
                return;
            }

            const slidesToShow = ($(window).outerWidth() * 3.3) / 375;

            this.$bannerPreviewList.on('init', () => {
                this.setFirstActivePreviewItem();
            });

            this.$bannerPreviewList.slick({
                infinite: false,
                slidesToShow,
                slidesToScroll: 1,
                dots: false,
                arrows: false,
                focusOnSelect: true,
                pauseOnHover: false,
                pauseOnFocus: false,
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: 'unslick',
                    },
                ],
            });
        },

        changeClassArrows(currentBanner) {
            this.$banner
                .find('.slick-arrow')
                .toggleClass('_white', currentBanner.hasClass('_white-text'));
        },
    };
});
